import * as types from 'model/actionTypes'
import { PartnerT, DictT } from 'shared/types/model'

export function receivePartners (partners: DictT<PartnerT>) {
  return {
    type: types.RECEIVE_PARTNERS,
    partners
  }
}
